import { AppContext } from "@/App.context";
import config from "@/config";
import { API_LOADING_ERROR, API_LOADING_ERROR_CUSTOM_WIDGET, API_NO_DATA_FOUND_ERROR, API_NO_DATA_FOUND_ERROR_CUSTOM_WIDGET, API_NO_DATA_FOUND_FOR_FILTERS_ERROR_CUSTOM_WIDGET, API_NOT_FOUND_ERROR, API_NOT_FOUND_ERROR_CUSTOM_WIDGET, ERROR_STATUS_CODES } from "@/lib/errors/error-constants";
import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";

export const getTotalStatistics = (token) => {
  return async (req, signal) => {
    const owners = await fetch(
      `${config.apiHost}/v1/${req.service}/budget/total-stats`,
      {
        method: "GET",
        signal,
        headers: {
          Authorization: token,
        },
      }
    );
    if (!owners.ok) {
      if (ERROR_STATUS_CODES.includes(owners.status)) {
        throw new Error(API_LOADING_ERROR_CUSTOM_WIDGET);
      }
      if (owners.status === 404) {
        throw new Error(API_NOT_FOUND_ERROR_CUSTOM_WIDGET);
      }
      throw new Error((await owners.json()).message);
    }
    const res = await owners.json();
    if (res?.data?.total_budget_amount === 0) {
      throw new Error(API_NO_DATA_FOUND_ERROR_CUSTOM_WIDGET);
    }
    return res;
  };
};

/**
 * @param {GetStatisticsReq} req
 * @param {any[]=} deps
 */
export const useTotalStats = (req, deps = []) => {
  const appContext = useContext(AppContext);
  const query = useQuery({
    queryKey: ["getTotalStatistics", appContext.idToken, req, ...deps],
    queryFn: ({ signal }) => getTotalStatistics(appContext.idToken)(req, signal),
    retry:false
  });
  return query;
};
